import { Modal, ModalBody, ModalHeader, CardBody, CardTitle } from 'reactstrap'
import { IconTrash } from '@tabler/icons-react'
import { IconX } from '@tabler/icons-react'
//@ts-ignore
import { Button } from 'dsm-react-lib'

interface DeleteProjectModalProps {
  isOpen: boolean
  toggle: () => void
  onDelete: () => void
  project: any
  isDeleting: boolean
}

const DeleteProjectModal: React.FC<DeleteProjectModalProps> = ({
  isOpen,
  toggle,
  onDelete,
  project,
  isDeleting
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered data-testid="delete-project-modal">
      <ModalHeader
        className={`!justify-between !border-0 !flex !items-center chat-primary theme-bg`}
        toggle={toggle}
        close={
          <IconX
            size={24}
            onClick={toggle}
            className="theme-text-subheading transition-colors duration-300 ease-in-out hover:text-white cursor-pointer"
            data-testid="close-button"
          />
        }>
        <div className="flex items-center">
          <IconTrash className="me-1" color="white" />
          <span className="text-white">Delete project?</span>
        </div>
      </ModalHeader>
      <ModalBody className="flex-grow-1">
        <div className="text-center border-0">
          <CardBody className="px-0 py-1">
            <CardTitle className="font-normal text-left">
              Are you sure you want to delete <b>{project?.name}</b>? This action cannot be undone.
            </CardTitle>
            {project?.memoryMode === 'ProjectOnly' ? (
              <CardTitle className="font-normal mt-1 text-left text-[var(--text-body)]">
                <strong>Note:</strong> Your chats will be preserved and moved to regular
                conversations, but all memories associated with this project will be permanently
                deleted.
              </CardTitle>
            ) : (
              <CardTitle className="font-normal mt-1 text-left text-[var(--text-body)]">
                <strong>Note:</strong> Your chats and memories will be preserved and moved to
                regular conversations.
              </CardTitle>
            )}
          </CardBody>
        </div>
        <div className={`flex justify-end gap-1 my-1 chat-primary`}>
          <Button
            label="Cancel"
            variant="outline"
            color="neutral"
            className="dsm-btn-neutral"
            onClick={toggle}
            data-testid="cancel-delete-project-button"
          />
          <Button
            label={isDeleting ? 'Deleting...' : 'Confirm'}
            color="danger"
            disabled={isDeleting}
            onClick={onDelete}
            data-testid="confirm-delete-project-button"
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

export default DeleteProjectModal
